import * as React from "react"
import { CloseButton, Toast, ToastContainer } from "react-bootstrap";
import { ListItemOperationType } from "../definitions/enums";
import { useListItemTransactionToast } from "../models/view/useListItemTransactionToast";
import { BsCheck2 } from "react-icons/bs";

export const ListItemTransactionToast = () => {
    const {
        operation,
        path,
        name,
        show,
        onClose
    } = useListItemTransactionToast();

    return (
        <ToastContainer className={`favorites-toast translate-middle ${show && 'favorites-show'}`} >
            <Toast show={show} onClose={onClose}>
                <Toast.Body className="d-flex align-items-center justify-content-between bg-dark rounded border-dark">
                    <div style={{ fontSize: '1.2rem' }}  className="d-flex align-items-center justify-content-between text-white">
                        <BsCheck2 size={25} className="me-1" /> {operation && operation === ListItemOperationType.Add ? 'Added to' : 'Removed from'}{' '}
                        <a href={path} target='_blank' className="text-decoration-underline ms-1 text-white">
                            {name ?? 'list'}
                        </a>
                    </div>
                     <CloseButton aria-label="Hide" onClick={onClose} variant="white"/>
                 </Toast.Body>
            </Toast>
        </ToastContainer>
    )
}